define('modules/accounts/status/products/mdirector/balance/transfer/form/view',['require','exports','module','views/BaseView','jquery','app','./../resume/view','helpers/viewHelpers','ldsh!./template'],function (require, exports, module) {
  "use strict";

  var BaseView = require("views/BaseView");
  var $ = require("jquery");
  var app = require("app");
  var TransferResumeView = require("./../resume/view");
  var viewHelpers = require("helpers/viewHelpers");

  var transferenceField = {
    "Email": "bonus",
    "SMS": "sms_country"
  };

  var View = BaseView.extend({
    template: require("ldsh!./template"),

    events: {
      "change #numSMSByCountryBalance": "countrySelected",
      "change [name^='transferType']": "showItemToRecharge",
      "submit #form-transfer": "submit"
    },

    initialize: function () {
      if (this.model) {
        this.listenTo(this.model, "sync request error", this.render);
      }
    },

    serialize: function () {
      return {
        group: this.group,
        model: this.model,
        balance: this.balance
      };
    },

    afterRender: function () {
      BaseView.prototype.afterRender.call(this);

      // this.addFormValidation(); // TODO: This is not working by now

      $("#numSMSByCountryBalance, #selectSubaccount").select2();

      if (this.balance.get("countryId")) {
        $("#numSMSByCountryBalance").select2("val", this.balance.get("countryId"));
        this._showNumSMS("#numSMSByCountryBalance");
      }

      app.i18n(this.el);
    },

    countrySelected: function (e) {
      this._showNumSMS(e.currentTarget);
    },

    _showNumSMS: function (el) {
      var numSMS = $(el).find(":selected").attr("data-sms");
      $("#numSmsCountryBalance").html(viewHelpers.formatNumber(numSMS));
    },

    showItemToRecharge: function (e) {
      var value = $(e.target).val();
      $('#selectedItem').text(value);
    },

    addFormValidation: function () {
      var self = this;
      $("#form-transfer")
        .bootstrapValidator({
          onSuccess: function (e) {
            e.preventDefault();
            self.submit(e);
          },
          fields: {
            selectSubaccount: {
              validators: {
                notEmpty: {
                  message: $.i18n.t("ACCOUNTS.STATUS.MDIRECTOR.BALANCE.MODAL.SELECT")
                }
              }
            },
            transferType: {
              validators: {
                notEmpty: {
                  message: $.i18n.t("ACCOUNTS.STATUS.MDIRECTOR.BALANCE.MODAL.SELECT_ITEM")
                }
              }
            },
            transferNumber: {
              validators: {
                notEmpty: {
                  message: $.i18n.t("ACCOUNTS.STATUS.MDIRECTOR.BALANCE.MODAL.TRANSFER_NO_EMPTY")
                },
                integer: {
                  message: $.i18n.t("ACCOUNTS.STATUS.MDIRECTOR.BALANCE.MODAL.MUST_BE_FLOAT")
                },
                numeric: {
                  message: $.i18n.t("ACCOUNTS.STATUS.MDIRECTOR.BALANCE.MODAL.MUST_BE_FLOAT")
                }
              }
            }
          }
        });
    },

    submit: function (event) {
      event.preventDefault();
      this.save();
      var transferResumeView = new TransferResumeView({
        el: "#transfer-modal-body",
        balance: this.balance,
        model: this.model,
        group: this.group
      });
      transferResumeView.render();
    },

    save: function () {
      var transferenceType = $('[name="transferType"]:checked').val();
      var field = transferenceField[transferenceType];
      var value = $('#transferNumber').val();
      var country = $("#numSMSByCountryBalance").val();
      var countrySms = $("#numSMSByCountryBalance option:selected").data("sms");
      var countryName = $("#numSMSByCountryBalance option:selected").text();

      var data = {
        "gruId": this.group.id,
        "empId": $('#selectSubaccount option:selected').val(),
        "empName": $('#selectSubaccount option:selected').text(),
        "field": field,
        "value": value,
        "country": country,
        "countrySms": countrySms,
        "countryName": countryName
      };
      this.model.set(data);
    }
  });
  module.exports = View;
});

